import { render, staticRenderFns } from "./SubTitle.vue?vue&type=template&id=015216e4&"
import script from "./SubTitle.vue?vue&type=script&lang=js&"
export * from "./SubTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports